module.exports = __webpack_public_path__ + "img/permaweb_news.1b3c0268.svg";